import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Leaf/AddressBlock/AddressBlock.css';

export const prototypeName = 'Servicebund.RodeoSteakDe:Component.AddressBlock';
export {styles};